import React from 'react';
import Link from 'gatsby-link';
import Markdown from 'react-markdown';
import Helmet from 'react-helmet';
import { Typography, Grid } from '@material-ui/core';
import styled from '../utils/styled';
import Section from '../components/Section';
import Button from '../components/Button';

const CardWrapperGrid = styled(Grid)(theme => ({
    container: true,
    spacing: 16,
    fontSize: '0.75em',
}));

const CardGrid = styled(Grid)(theme => ({
  textAlign: 'center',
}));

const overal = `
Me korraldame ka avalikke sündmuseid. Leiate meie sündmuste seast endale sobiliku seikluse. On võimalik osaleda nii individuaalselt kui ka kogu perega.
`;

const Services = ({ data }) => {
  return (
    <Section>
      <Grid item xs={12} sm={8}>
        <Helmet title="Pereseiklus - Suusa & laua nädalavahetus Võnnus (Cēsis, Läti) 15-16 veebruar 2020" />
        <CardWrapperGrid id="events" container justify="center" spacing={16}>
              <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScyu0V2WIK4ej66YQFH_oA99PcAPOqUQTSUDGNlfSQHPNPIeA/viewform?embedded=true" width="650" height="2550" frameborder="0" marginheight="0" marginwidth="0">Loading...</iframe>
        </CardWrapperGrid>
      </Grid>
    </Section>
  );
};
export default Services;



// WEBPACK FOOTER //
// ./src/pages/ozolkalns.js